import { MutationTree } from 'vuex'
import { State } from './'

const mutations: MutationTree<any> = {
	'setCurrentScreen'(state: State, payload) {
		state.currentScreen = payload
	},
	'onAnswerScreen'(state: State, payload) {
		state.onAnswerScreen = payload
	},
	'userOnResultScreen'(state: State, payload) {
		state.userOnResultScreen = payload
	},
	'setUserChoices'(state: State, payload) {
		state.userChoices = payload
	},
	'setRandomizedOptions'(state: State, payload) {
		state.randomizedOptions = payload
	},
	'setFormInputValues'(state: State, payload) {
		state.formInputValues = payload
	},
	'setQuestionVisited'(state: State, payload) {
		state.visitedQuestions.push(payload)
	}
}

export default mutations
